/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  CreatePageAnnotationBody,
  DeletePageAnnotation200,
  ForbiddenResponse,
  GetPageAnnotations200,
  InternalServerErrorResponse,
  NotFoundResponse,
  PageAnnotation,
  UnauthorizedResponse,
  UpdatePageAnnotationBody,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Creates a new page annotation (sticky note)
 */
export const createPageAnnotation = (
  organizationId: string,
  projectId: string,
  pageId: string,
  createPageAnnotationBody: CreatePageAnnotationBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PageAnnotation>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/annotations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPageAnnotationBody,
      signal,
    },
    options
  );
};

export const getCreatePageAnnotationMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPageAnnotation>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      pageId: string;
      data: CreatePageAnnotationBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPageAnnotation>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    pageId: string;
    data: CreatePageAnnotationBody;
  },
  TContext
> => {
  const mutationKey = ["createPageAnnotation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPageAnnotation>>,
    {
      organizationId: string;
      projectId: string;
      pageId: string;
      data: CreatePageAnnotationBody;
    }
  > = (props) => {
    const { organizationId, projectId, pageId, data } = props ?? {};

    return createPageAnnotation(
      organizationId,
      projectId,
      pageId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePageAnnotationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPageAnnotation>>
>;
export type CreatePageAnnotationMutationBody = CreatePageAnnotationBody;
export type CreatePageAnnotationMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new page annotation (sticky note)
 */
export const useCreatePageAnnotation = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPageAnnotation>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        pageId: string;
        data: CreatePageAnnotationBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPageAnnotation>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    pageId: string;
    data: CreatePageAnnotationBody;
  },
  TContext
> => {
  return useMutation(
    getCreatePageAnnotationMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Retrieves all page annotations for a case
 */
export const getPageAnnotations = (
  organizationId: string,
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetPageAnnotations200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/page-annotations`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetPageAnnotationsQueryKey = (
  organizationId: string,
  projectId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/page-annotations`,
  ] as const;
};

export const getGetPageAnnotationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPageAnnotations>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPageAnnotations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPageAnnotationsQueryKey(organizationId, projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPageAnnotations>>
  > = ({ signal }) =>
    getPageAnnotations(organizationId, projectId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPageAnnotations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPageAnnotationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPageAnnotations>>
>;
export type GetPageAnnotationsQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPageAnnotations<
  TData = Awaited<ReturnType<typeof getPageAnnotations>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPageAnnotations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageAnnotations>>,
          TError,
          Awaited<ReturnType<typeof getPageAnnotations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPageAnnotations<
  TData = Awaited<ReturnType<typeof getPageAnnotations>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPageAnnotations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageAnnotations>>,
          TError,
          Awaited<ReturnType<typeof getPageAnnotations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPageAnnotations<
  TData = Awaited<ReturnType<typeof getPageAnnotations>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPageAnnotations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all page annotations for a case
 */

export function useGetPageAnnotations<
  TData = Awaited<ReturnType<typeof getPageAnnotations>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPageAnnotations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPageAnnotationsQueryOptions(
    organizationId,
    projectId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Updates a page annotation
 */
export const updatePageAnnotation = (
  organizationId: string,
  projectId: string,
  annotationId: string,
  updatePageAnnotationBody: UpdatePageAnnotationBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PageAnnotation>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/page-annotations/${annotationId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updatePageAnnotationBody,
      signal,
    },
    options
  );
};

export const getUpdatePageAnnotationMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePageAnnotation>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      annotationId: string;
      data: UpdatePageAnnotationBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePageAnnotation>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    annotationId: string;
    data: UpdatePageAnnotationBody;
  },
  TContext
> => {
  const mutationKey = ["updatePageAnnotation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePageAnnotation>>,
    {
      organizationId: string;
      projectId: string;
      annotationId: string;
      data: UpdatePageAnnotationBody;
    }
  > = (props) => {
    const { organizationId, projectId, annotationId, data } = props ?? {};

    return updatePageAnnotation(
      organizationId,
      projectId,
      annotationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePageAnnotationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePageAnnotation>>
>;
export type UpdatePageAnnotationMutationBody = UpdatePageAnnotationBody;
export type UpdatePageAnnotationMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates a page annotation
 */
export const useUpdatePageAnnotation = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePageAnnotation>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        annotationId: string;
        data: UpdatePageAnnotationBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updatePageAnnotation>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    annotationId: string;
    data: UpdatePageAnnotationBody;
  },
  TContext
> => {
  return useMutation(
    getUpdatePageAnnotationMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Deletes a page annotation
 */
export const deletePageAnnotation = (
  organizationId: string,
  projectId: string,
  annotationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeletePageAnnotation200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/page-annotations/${annotationId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeletePageAnnotationMutationOptions = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePageAnnotation>>,
    TError,
    { organizationId: string; projectId: string; annotationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePageAnnotation>>,
  TError,
  { organizationId: string; projectId: string; annotationId: string },
  TContext
> => {
  const mutationKey = ["deletePageAnnotation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePageAnnotation>>,
    { organizationId: string; projectId: string; annotationId: string }
  > = (props) => {
    const { organizationId, projectId, annotationId } = props ?? {};

    return deletePageAnnotation(
      organizationId,
      projectId,
      annotationId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePageAnnotationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePageAnnotation>>
>;

export type DeletePageAnnotationMutationError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes a page annotation
 */
export const useDeletePageAnnotation = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePageAnnotation>>,
      TError,
      { organizationId: string; projectId: string; annotationId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deletePageAnnotation>>,
  TError,
  { organizationId: string; projectId: string; annotationId: string },
  TContext
> => {
  return useMutation(
    getDeletePageAnnotationMutationOptions(options),
    queryClient
  );
};
